export default __webpack_public_path__ + "static/media/LenkradschonerTOPTEX.0220ce0a.jpg";